import React from "react";
import * as CHQ from "chq";

import { CommentLink, ProfileLink } from "app/links";
import { Trans } from "app/utils";

import LazyEditorOutput from "components/editor/LazyEditorOutput";

import NotificationBody from "./NotificationBody";

type PostCommentedNotificationProps = {
  notification: CHQ.NotificationPostCommented;
  tabIndex?: number;
};

const PostCommentedNotification: React.FC<PostCommentedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>
      <CommentLink comment={entity} tabIndex={tabIndex || 0}>commented</CommentLink> on your post:
    </Trans>
    <br />
    <LazyEditorOutput output={entity.body} tabIndex={tabIndex} />
  </NotificationBody>
);

export default PostCommentedNotification;
